import { axiosObject } from '../setup';

function getHistoricalRatesFromProduction(payload) {
  return new Promise((resolve, reject) => {
    let uri = `${process.env.NX_PUBLIC_RATES_API_URL}/multiple-pairs-date/rates-history`;
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getHistoricalRatesFromStaging(payload) {
  return new Promise((resolve, reject) => {
    let uri = `${process.env.NX_PUBLIC_RATES_API_URL}/multiple-pairs-date/rates-history`;
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export { getHistoricalRatesFromProduction, getHistoricalRatesFromStaging };
